"use client";

import { useState } from "react";
import { Check, Copy } from "lucide-react";
import clsx from "clsx";

export function CopyCodeButton({ text }: { text: string }) {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    } catch (error) {
      console.error("Failed to copy text", error);
    }
  };

  return (
    <button
      type="button"
      onClick={copyToClipboard}
      className={clsx(
        "absolute right-3 top-3 rounded-xl border border-white/15 bg-white/10 p-2.5 text-gray-300 opacity-0 backdrop-blur transition-all hover:bg-white/20 hover:text-white focus:opacity-100 group-hover:opacity-100",
        isCopied && "text-green-400 opacity-100"
      )}
      aria-label="Copy code"
    >
      {isCopied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
    </button>
  );
}
